// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__ZI0fz","modalForm":"UpgradeEpcsModal_modalForm__eQSkX","modalFooter":"UpgradeEpcsModal_modalFooter__2Trpp"};